import * as React from 'react';

export const PictureBoxTablet = (props: React.DetailedHTMLProps<React.SVGAttributes<SVGElement>, SVGElement>) => {
  const { ref, ...rest } = props;

  return (
  // tslint:disable:max-line-length
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="90" height="105" viewBox="0 0 90 105">
      <g fill="none" fillRule="evenodd" stroke="#13344B" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".5">
        <path d="M-7.144 50.266s-.715 14.568 0 25.91c.491 7.89 15.275 27.614 15.275 27.614"/>
        <path d="M3.843 58.514l4.288 6.32s-2.144 36.445 0 38.956c2.858 3.362 64.897-3.273 64.897-3.273s.893-25.91 0-37.207c-.09-1.39-3.395-4.482-3.395-4.482M27.113 64.88l-18.357-.046M48.06 64.88l21.573-.628"/>
        <path d="M36.09 26.238s1.028 21.428 0 42.81l-49.353-21.382V33.23"/>
        <path d="M36.09 69.048l40.823-13.672s3.574-30.617 0-41.286c0 0-34.704 5.603-40.822 11.207M-11.655 9.472s-7.593 8.921-10.943 18.245c-1.027 2.824 47.746 19.949 47.746 19.949l10.943-22.37-47.746-15.824z"/>
        <path d="M-11.655 9.472L26.71 1l50.202 13.09 12.774 14.479-12.774-2.331M26.711 1v21.203M60.343 36.638v5.424s-.625.224-.938.224c-.313 0-.357-5.155 0-5.424.357-.269.938-.224.938-.224zM60.075 33.724c.357 0 .536.628.268 1.166-.313.538-.849.762-1.161.269-.313-.493-.134-1.39.893-1.435z"/>
        <path d="M52.482 42.241c-2.948-6.275 2.546-11.565 7.861-12.417 2.323-.358 7.057.404 7.012 5.917-.044 7.89-11.21 14.3-14.873 6.5"/>
      </g>
    </svg>
    // tslint:enable:max-line-length
  );
};
